module.exports = __webpack_public_path__ + "60058ced464f2e8d93b9e9e27010aa2b.svg";